import CheckIcon from '@mui/icons-material/Check';
import { Box, ButtonBase } from '@mui/material';
import { FC } from 'react';

import { Piece, PieceAssetSize } from '@apiContract';

import { getPieceAsset } from '@utils/piece';

import {
  sxThumbnailButton,
  sxThumbnailImage,
  sxThumbnailValidatedBadge,
  sxThumbnailValidatedImage,
  sxThumbnailsContainer,
} from '../styles';

type PieceThumbnailsProps = {
  pieces: Piece[];
  validatedIds: number[];
  onSelect: (index: number) => void;
};

export const PieceThumbnails: FC<PieceThumbnailsProps> = ({ pieces, validatedIds, onSelect }) => {
  if (!pieces.length) return null;

  return (
    <Box sx={sxThumbnailsContainer}>
      {pieces.map((piece, index) => {
        const thumbUrl =
          getPieceAsset(piece.pieceAssets || [], PieceAssetSize.Small)?.url || '/images/empty_thumbnail.png';
        const isPieceValidated = validatedIds.includes(piece.id);

        return (
          <ButtonBase
            key={piece.id}
            onClick={() => onSelect(index)}
            aria-label={`Open piece ${piece.id} preview`}
            sx={sxThumbnailButton}
          >
            <Box
              component="img"
              src={thumbUrl}
              alt=""
              sx={[sxThumbnailImage, isPieceValidated && sxThumbnailValidatedImage]}
            />
            {isPieceValidated && (
              <Box sx={sxThumbnailValidatedBadge}>
                <CheckIcon />
              </Box>
            )}
          </ButtonBase>
        );
      })}
    </Box>
  );
};
